/**
 * developer friendly version of font types configuration - please edit here.
 */
const fontTypes: Map<string, string[]> = new Map();

fontTypes.set("sans-serif", [
    "Anton",
    "Asap",
    "Heebo",
    "Hind",
    "Kanit",
    "Karla",
    "Lato",
    "Montserrat",
    "Mukta",
    "NotoSans",
    "OpenSans",
    "Oxygen",
    "PTSans",
    "Poppins",
    "Raleway",
    "SourceSansPro",
    "Ubuntu",
    "VarelaRound",
]);

fontTypes.set("serif", [
    "Acme",
    "Arvo",
    "Bree",
    "Lora",
    "Merriweather",
]);

fontTypes.set("monospace", [
    "Inconsolata",
]);

/**
 * internal indexed configuration - for quick matching
 */
const fontTypesOptimised: Map<string, string> = new Map();

fontTypes.forEach((fontNameValues, fontTypeKey) => {
    fontNameValues.forEach((fontNameValue) => {
        fontTypesOptimised.set(fontNameValue, fontTypeKey);
    });
});

/**
 * Returns type of the font based on the static configuration
 *
 * @param fontName font family name
 */
export function mapFontType(fontName: string): string {
    return fontTypesOptimised.get(fontName) || "sans-serif";
}
